/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IDlvryBannerBlockViewProps } from './dlvry-banner-block';

export default (props: IDlvryBannerBlockViewProps) => {
    const {
        BannerBlock,
        image,
        imageLink,
        content
    } = props;

    return (
        <Module {...BannerBlock}>
            {imageLink && (
                <Node {...imageLink}>
                    {image}
                </Node>
            )}
            {content}
        </Module>
    );
};
